export const SignUp = {
  lastName: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  firstName: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  email: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    },
    {
      type: 'type',
      expected: 'email',
      message: 'Ce n\'est pas un email valide !'
    }
  ],
  password: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    },
    {
      type: 'minLength',
      expected: 7,
      message: 'Votre mot de passe doit faire plus de 7 caractères !'
    }
  ],
  passwordConfirm: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  phone: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ]
}

export const ResetPassword = [
  {
    type: 'required',
    expected: true,
    message: 'Ce champ est obligatoire'
  },
  {
    type: 'minLength',
    expected: 6,
    message: 'Votre mot de passe doit faire au moins 7 caractères !'
  },
  {
    type: 'maxLength',
    expected: 11,
    message: 'Votre mot de passe doit faire moins de 10 caractères !'
  }
]



// WEBPACK FOOTER //
// ./src/components/authentication/validators.js